import { IApplicationState } from '../../types/redux';

export const selectSelectedEntities = (state: IApplicationState) => state.selected;
